import React, { useContext } from 'react';
export var PortalContext = /*#__PURE__*/React.createContext(undefined);
export function usePortal(props) {
  var portalFromContext = useContext(PortalContext);
  return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}